/* eslint-disable @typescript-eslint/no-unused-vars -- kept alongside the implementation it belongs to, which is still commented out */

// ----------------------------------------------------------------------------

function scroll(element: HTMLElement): void {
    const dropdownMenu = null;
    const dropdownLeft = null;
    const dropdownRight = null;

    /*
     * // Create event (show bs dropdown)
     * element.addEventListener('show.bs.dropdown', function (evt) {
     *  // Get element dropdown menu
     *  dropdownMenu = evt.target.querySelector('.dropdown-menu');
     *
     *  // Move to...
     *  $(evt.target).parent().append($(dropdownMenu).detach());
     *
     *  // Get Bounding Client Rect
     *  const rect = evt.target.getBoundingClientRect();
     *
     *  // Dropdown Menu Top
     *  const top = rect.height + 1;
     *
     *  // Dropdown Menu Left
     *  dropdownLeft = rect.left;
     *  dropdownRight = 'auto';
     *
     *  // Dropdown Menu Right
     *  if (dropdownMenu.hasClass('dropdown-menu-right')) {
     *      dropdownLeft = 'auto';
     *      dropdownRight = window.innerWidth - (rect.left + rect.width);
     *  }
     *
     *  // Dropdown Menu Style
     *  dropdownMenu.style.display = 'block';
     *  dropdownMenu.style.minWidth = '160px';
     *  dropdownMenu.style.top = top + 'px';
     *  dropdownMenu.style.left = dropdownLeft === 'auto' ? dropdownLeft : dropdownLeft + 'px';
     *  dropdownMenu.style.right = dropdownRight === 'auto' ? dropdownRight : dropdownRight + 'px';
     * });
     *
     * // Create event (scroll)
     * $(element).on('scroll', function (evt) {
     *  if (dropdownMenu == null) {
     *      return;
     *  }
     *
     *  console.log(evt.target.scrollLeft);
     *  console.log(dropdownLeft, dropdownRight);
     *  console.log(dropdownRight + evt.target.scrollLeft);
     *
     *  if (dropdownMenu.style.left !== 'auto') {
     *      dropdownMenu.style.left = dropdownLeft - evt.target.scrollLeft + 'px';
     *  } else {
     *      dropdownMenu.style.right = dropdownRight + evt.target.scrollLeft + 'px';
     *  }
     * });
     *
     * // Create event (hide bs dropdown)
     * element.addEventListener('hide.bs.dropdown', function (evt) {
     *  if (dropdownMenu == null) {
     *      return;
     *  }
     *
     *  $(evt.target).append($(dropdownMenu).detach());
     *
     *  // Dropdown Menu Style
     *  dropdownMenu.style.display = 'none';
     *
     *  // Clear
     *  dropdownMenu = null;
     * });
     */
}

// ----------------------------------------------------------------------------

export default scroll;
